import { isNotInRange } from "../../utils/customFunctions";

export const validateHandoutData = async ({
	title,
	description,
	languageId,
	imageCover,
	handoutPdf,
	handoutVideo,
	isActive,
	showInHandoutsSection,
	id, // This will be present in edit mode
	imageCoverUrl, // This will be present if existing cover image exists
	handoutPdfUrl, // This will be present if existing PDF exists
	...rest
}) => {
	const errors = {};

	// Validate title (single language)
	if (!title || (typeof title === 'string' && title.trim() === '')) {
		errors.title = "ra.validation.required";
	} else if (typeof title === 'string' && isNotInRange({ min: 3, max: 100, str: title })) {
		errors.title = {
			message: "validationErrors.minMax.titles",
			args: { min: 3, max: 100 },
		};
	}

	// Validate description (single language)
	if (!description || (typeof description === 'string' && description.trim() === '')) {
		errors.description = "ra.validation.required";
	} else if (typeof description === 'string' && isNotInRange({ min: 10, max: 500, str: description })) {
		errors.description = {
			message: "validationErrors.minMax.descriptions",
			args: { min: 10, max: 500 },
		};
	}

	// Validate language selection
	if (!languageId) {
		errors.languageId = "ra.validation.required";
	}

	// Validate cover image (required for create, optional for edit if existing)
	const isEdit = !!id;
	const hasExistingCoverImage = !!imageCoverUrl;
	const hasExistingPdf = !!handoutPdfUrl;

	if (!imageCover || !imageCover.rawFile) {
		// Only require cover image if it's create mode OR edit mode without existing image
		if (!isEdit || !hasExistingCoverImage) {
			errors.imageCover = "handouts.validationErrors.required.imageCover";
		}
	}

	// Validate PDF file (required for create, optional for edit if existing)
	if (!handoutPdf || !handoutPdf.rawFile) {
		// Only require PDF if it's create mode OR edit mode without existing PDF
		if (!isEdit || !hasExistingPdf) {
			errors.handoutPdf = "handouts.validationErrors.required.handoutPdf";
		}
	} else {
		// Validate PDF file type
		const pdfType = handoutPdf.rawFile?.type;
		if (pdfType && pdfType !== "application/pdf") {
			errors.handoutPdf = "handouts.validationErrors.invalidPdfType";
		}
	}

	// Validate video file (optional, but if provided, must be valid)
	if (handoutVideo && handoutVideo.rawFile) {
		const videoType = handoutVideo.rawFile?.type?.split("/")[0];
		if (videoType && videoType !== "video") {
			errors.handoutVideo = "handouts.validationErrors.invalidVideoType";
		}
	}

	// Validate cover image file type
	if (imageCover && imageCover.rawFile) {
		const imageType = imageCover.rawFile?.type?.split("/")[0];
		if (imageType && imageType !== "image") {
			errors.imageCover = "handouts.validationErrors.invalidImageType";
		}
	}

	return errors;
};
